import React from 'react';
import {useTranslation} from 'react-i18next';

import {EContentType} from 'src/constants';
import {TMessageMatcher} from 'src/containers/MessageMatchers/definitions';
import {ImageIcon} from 'src/icons';
import {DocumentImage} from 'src/images';

import * as SS from '../style';
import {FOOTER_TIME} from '../utils';
import * as S from './style';

type TProps = {
  content: TMessageMatcher['content'];
  contentType: EContentType;
  children: React.ReactNode;
};

export const ViberContent = React.memo<TProps>(({contentType, content, children}) => {
  const {t} = useTranslation();

  const attachmentUrl = content.attachment?.fileUrl;

  const isInline =
    contentType === EContentType.TEXT || (contentType === EContentType.BUTTON && !content.caption);

  return (
    <SS.Message isInline={isInline}>
      {contentType === EContentType.TEXT && children}
      {contentType === EContentType.IMAGE && attachmentUrl && <SS.Image src={attachmentUrl} />}
      {contentType === EContentType.IMAGE && !attachmentUrl && (
        <S.EmptyImage>
          <SS.Icon as={ImageIcon} />
        </S.EmptyImage>
      )}
      {contentType === EContentType.BUTTON && (
        <>
          {children}
          {attachmentUrl && <SS.Image src={attachmentUrl} />}
          {content.caption && <S.Button title={content.action ?? ''}>{content.caption}</S.Button>}
        </>
      )}
      {contentType === EContentType.DOCUMENT && (
        <>
          <S.Document src={DocumentImage} />
          {attachmentUrl}
          <S.Button>{t('MessagePreview:open')}</S.Button>
        </>
      )}
      <SS.Time>
        <span>{FOOTER_TIME}</span>
      </SS.Time>
    </SS.Message>
  );
});

ViberContent.displayName = 'ViberContent';
